import { ref } from '@vue/composition-api'
import { errorNotification } from '@/utils/toast-notifications'

export default function useList(ctx) {
  const data = ref([])
  const tableColumns = [
    'name',
    'class_name',
    'zone',
    'air_distance',
    'concurrent_drivers',
    'maximum_air_distance',
    'time_out',
    'time_to_increase_distance',
    'time_to_max_distance',
    'unit',
  ]
  const page = ref(1)
  const perPage = ref(10)
  const loading = ref(false)
  const fetch = async () => {
    if (loading.value) return
    try {
      loading.value = true
      const res = (await ctx.root.$store.dispatch('dispatch/fetchDispatchConfigurations')).data.data
      data.value = res
    } catch (error) {
      errorNotification('error fetching list')
    } finally {
      loading.value = false
    }
  }
  const viewDispatchConfig = evt => ctx.root.$router.push(`/dispatch-configurations/edit/${evt.id}`)

  fetch()

  return {
    loading,
    fetch,
    data,
    tableColumns,
    page,
    perPage,
    viewDispatchConfig,
  }
}
